import BenefitsPharmacy from './BenefitsPharmacy';

export default BenefitsPharmacy;
